export const ArrowIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 0.5V7C11.5 7.4 11.34 7.78 11.06 8.06C10.78 8.34 10.4 8.5 10 8.5H0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 5L0.5 8.5L4 12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
